// extracted by mini-css-extract-plugin
module.exports = {"flex":"HomePageTiles_flex__2zn3r","grow":"HomePageTiles_grow__1WMF5"};